export default __webpack_public_path__ + "static/media/pdt-detail.e9aba99d.webp";